export default __webpack_public_path__ + "static/media/learnArabicChild.567ada6e.jpeg";